// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationProcedureId } from './FermentationProcedure';
import { fermentationLineTypeId } from './FermentationLineType';
import { fermLineDriveEnum } from './FermLineDriveEnum';
import { invResourceId } from './InvResource';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationProcedureLineId = (z.number());
export const fermentationProcedureLine = z.object({
    id: fermentationProcedureLineId,
    procedure_id: fermentationProcedureId,
    line_type_id: fermentationLineTypeId,
    drive: fermLineDriveEnum,
    default_resource_id: invResourceId.nullable(),
    default_concentration_pct: z.string().nullable(),
    is_optional: z.boolean(),
    display_order: z.number(),
    notes: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const fermentationProcedureLineInitializer = z.object({
    id: fermentationProcedureLineId.optional(),
    procedure_id: fermentationProcedureId,
    line_type_id: fermentationLineTypeId,
    drive: fermLineDriveEnum.optional(),
    default_resource_id: invResourceId.optional().nullable(),
    default_concentration_pct: z.string().optional().nullable(),
    is_optional: z.boolean().optional(),
    display_order: z.number().optional(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const fermentationProcedureLineMutator = z.object({
    id: fermentationProcedureLineId.optional(),
    procedure_id: fermentationProcedureId.optional(),
    line_type_id: fermentationLineTypeId.optional(),
    drive: fermLineDriveEnum.optional(),
    default_resource_id: invResourceId.optional().nullable(),
    default_concentration_pct: z.string().optional().nullable(),
    is_optional: z.boolean().optional(),
    display_order: z.number().optional(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FermentationProcedureLine.js.map